// FoldIntoPlanToggle — the one-tap "put today's walk-in work on the plan"
// control for checkout Step 1. Controlled Yes/No; the parent recomputes the
// collect-today figure and passes the flag into the commit.
// Rendered only when there is a plan AND at least one walk-in line marked Done.

export default function FoldIntoPlanToggle({ value = false, onChange, embedded = false, collectTodayNote = null }) {
  return (
    <div
      data-testid="fold-toggle"
      // When embedded, drop the standalone card chrome so this reads as the
      // footer of the "Added at the chair" table it acts on (see ItemsTable).
      className={embedded
        ? "bg-sky-50/70 p-4"
        : "bg-sky-50 border border-sky-200 rounded-xl p-3.5"}
    >
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <div className="text-sm font-medium text-slate-800">
            Include Today's Scheduled &/or Add-On Procedures to Treatment Plan Billing
          </div>
          <div className="text-xs text-slate-600 mt-0.5">
            {value
              ? "It's part of the plan now and billed on the plan's schedule."
              : "Right now it's billed at this visit. Turn this on to spread it across the plan instead."}
          </div>
        </div>
        <div className="inline-flex rounded-full border border-slate-300 overflow-hidden bg-white shrink-0 text-xs">
          <button
            type="button"
            data-testid="fold-yes"
            aria-pressed={value ? "true" : "false"}
            onClick={() => onChange?.(true)}
            className={"px-4 py-1.5 " + (value ? "bg-sky-700 text-white font-medium" : "text-slate-600")}
          >
            Yes
          </button>
          <button
            type="button"
            data-testid="fold-no"
            aria-pressed={!value ? "true" : "false"}
            onClick={() => onChange?.(false)}
            className={"px-4 py-1.5 border-l border-slate-200 " + (!value ? "bg-slate-700 text-white font-medium" : "text-slate-600")}
          >
            No
          </button>
        </div>
      </div>
      {value && collectTodayNote ? (
        <div
          data-testid="fold-collect-note"
          className="mt-3 rounded-lg border border-sky-300 bg-white/80 px-3 py-2 text-sm font-semibold text-sky-900"
        >
          {collectTodayNote}
        </div>
      ) : null}
    </div>
  );
}
